import React from "react";

import DropdownPortal from "../../ui/components/DropdownMenu/DropdownPortal";

import TableCell from "./TableCell";

export default function TableCellDropdownMenu({ options }) {
	return (
		<TableCell sticky collapsing>
			<DropdownPortal
				fitted
				options={options}
				style={{
					position: "absolute",
					display: "flex",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					justifyContent: "center",
					alignItems: "center",
				}}
				iconStyle={{
					height: "auto",
				}}
			/>
		</TableCell>
	);
}
